import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { UrlValidatorService } from '../../core/services/url-validator.service';
import { IProjectRegistration, IProjectRegistrationPartner } from './../../shared/interfaces/projectRegistration.Interfaces';

@Injectable()
export class ProjectRegistrationService {
     baseUrl: string = environment.API_URL;
    serviceBase = this.baseUrl + '/api/registerProject';
    organizationUrl = this.baseUrl + '/api/organization/';
    homeInspectionUrl = this.baseUrl + '/api/homeInspection/';
    queryString: string;
    constructor(private http: HttpClient, private urlValidator: UrlValidatorService) { }

    // Get partner
    getPartner(masterProjectId: any, selectedLanguage: string) {
        const sanitizedMasterProjectId = this.urlValidator.sanitizeParam(masterProjectId);
        const sanitizedSelectedLanguage = this.urlValidator.sanitizeParam(selectedLanguage);
        const params = new HttpParams()
            .set('masterProjectId', sanitizedMasterProjectId)
            .set('selectedLanguage', sanitizedSelectedLanguage);
        return this.http.get<Array<IProjectRegistrationPartner>>(this.serviceBase + '/getPartner', { params });
    }

    getProjectDetailForRegistration(masterProjectId: any) {
        const sanitizedMasterProjectId = this.urlValidator.sanitizeParam(masterProjectId);
        const params = new HttpParams().set('masterProjectId', sanitizedMasterProjectId);
        return this.http.get<IProjectRegistration>(this.serviceBase + '/getProjectDetailForRegistration', { params });
    }

    getAllMasters = function (selectedLanguage: string) {
        const sanitizedSelectedLanguage = this.urlValidator.sanitizeParam(selectedLanguage);
        const params = new HttpParams().set('selectedLanguage', sanitizedSelectedLanguage);
        return this.http.get(this.serviceBase + '/getAllMasters', { params });
    };

    saveProjectRegistrationDetails = function (registerProject: IProjectRegistration) {
        return this.http.post(this.serviceBase + '/saveProjectRegistrationDetails', registerProject);
    };

    downloadAssociatedModels(masterProjectId, registeredProjectId): Observable<any> {
        const sanitizedMasterProjectId = this.urlValidator.sanitizeParam(masterProjectId);
        const sanitizedRegisteredProjectId = this.urlValidator.sanitizeParam(registeredProjectId);
        const params = new HttpParams()
            .set('masterProjectId', sanitizedMasterProjectId)
            .set('registeredProjectId', sanitizedRegisteredProjectId);
        return this.http.get(this.serviceBase + '/downloadAssociatedModels', { params, responseType: "blob", observe: 'response' });
    }

    getMasterProjectDetails(masterProjectId: any) {
        const sanitizedMasterProjectId = this.urlValidator.sanitizeParam(masterProjectId);
        const params = new HttpParams().set('masterProjectId', sanitizedMasterProjectId);
        return this.http.get<any>(this.serviceBase + '/getMasterProjectDetails', { params });
    }

    updateProjectRegistrationDetails = function (registerProject: IProjectRegistration, masterProjectId: any) {
        this.queryString = '/updateProjectRegistrationDetails?masterProjectId=' + masterProjectId;
        return this.http.put(this.serviceBase + this.queryString, registerProject);
    };

    GetOrganizationData() {
        return this.http.get<any>(this.organizationUrl + 'getOrganizationData');
    }
    getAllPartner(selectedLanguage: string, projectId: any) {
        this.queryString = this.baseUrl + '/api/zeroCarbon/GetAllPartners?selectedLanguage=' + selectedLanguage + '&projectId=' + projectId;
        return this.http.get<Array<IProjectRegistrationPartner>>(this.queryString);
    }

    ApplyforZCR(projectId: any, reportingYear: any, reportingMonth: any, partnerId: any) {
        this.queryString = this.baseUrl + '/api/zeroCarbon/ApplyforZCorZCR?projectId=' + projectId + '&reportingYear=' + reportingYear + '&reportingMonth=' + reportingMonth + '&partnerId=' + partnerId + '&type=ZCR';
        return this.http.post(this.queryString,null);
    }
    ApplyforZC(projectId: any, reportingYear: any, reportingMonth: any, partnerId: any) {
        this.queryString = this.baseUrl + '/api/zeroCarbon/ApplyforZCorZCR?projectId=' + projectId + '&reportingYear=' + reportingYear + '&reportingMonth=' + reportingMonth + '&partnerId=' + partnerId + '&type=ZC';
        return this.http.post(this.queryString, null);
    }

    DownloadAgreementDoc() {
        const queryString =this.baseUrl + '/api/registerProject/downloadAgreementDoc';
        return this.http.get(queryString, { observe: 'response', responseType: 'blob' })
            .pipe(
                map(results => {
                    return { data: results.body, fileName: results.headers.get('fileName') };
                })
            );
    }
    
    
}

